import has from 'lodash/has';

const isFeatureEnabled = (feature, flags = {}) => {
  return has(flags, feature) && flags[feature] === true;
};

export default isFeatureEnabled;
